// extracted by mini-css-extract-plugin
export default {"selector":"GbalE","filled":"OOvGu"};